{
  "$id": "module://user-defined-field",
  "$schema": "wealthlane://schemas/domain",
  "title": "User Defined Field",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "moduleId": {
      "type": "string",
      "title": "Module",
      "widget": "select",
      "format": "udf-module",
      "noBlank": true
    },
    "fieldName": {
      "type": "string",
      "title": "Field Name",
      "widget": "text",
      "noBlank": true,
      "maxLength": 35
    },
    "fieldType": {
      "type": "string",
      "title": "Field Type",
      "widget": "text",
      "noBlank": true,
      "default": "Text"
    },
    "isMandatory": {
      "type": "string",
      "title": "Is Mandatory?",
      "widget": "select",
      "format": "udf-yes-no",
      "noBlank": true
    },
    "status": {
      "type": "string",
      "title": "Status",
      "widget": "select",
      "format": "udf-status",
      "noBlank": true
    },
    "orderNumber": {
      "type": "number",
      "title": "Order Number",
      "minimum": 1,
      "maximum": 9999999
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 500,
      "adapterProps": { "rows": 5 }
    }
  }
}
